import * as GeoSearch from "leaflet-geosearch";
import { GeoSearchControl } from "leaflet-geosearch";
import { useMap } from "react-leaflet";
import { useEffect } from "react";
import "../../../node_modules/leaflet-geosearch/dist/geosearch.css";

const MapSearch = () => {
  const provider = new GeoSearch.OpenStreetMapProvider();
  const searchControl = new GeoSearchControl({
    provider: provider,
    style: "bar",
    showMarker: false,
  });

  const map = useMap();

  useEffect(() => {
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, []);

  return null;
};

export default MapSearch;